
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

interface PregnancyWeekSelectorProps {
  selectedWeek: string | null;
  onWeekSelect: (week: string) => void;
}

export function PregnancyWeekSelector({ selectedWeek, onWeekSelect }: PregnancyWeekSelectorProps) {
  const { language } = useLanguage();
  const weekLabel = t('generate.week', language);
  const pregnancyWeeks = Array.from({ length: 40 }, (_, i) => `${weekLabel} ${i + 1}`);
  
  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium mb-2">{t('generate.selectWeek', language)}</h3>
      <div className="flex flex-wrap gap-2">
        {pregnancyWeeks.map((week) => (
          <button
            key={week}
            onClick={() => onWeekSelect(week)}
            className={`px-3 py-1 rounded-full text-sm ${
              selectedWeek === week 
                ? "bg-primary text-primary-foreground" 
                : "bg-muted hover:bg-muted/80"
            }`}
          >
            {week}
          </button>
        ))}
      </div>
    </div>
  );
}
